/**************************************************
 * Nombre:       Dialogo_Politicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Dialogo_Politicas = ({datos}) => {


    const htmlFrom = (htmlString) => {
        const cleanHtmlString = DOMPurify.sanitize(htmlString,
            {USE_PROFILES: {html: true}});
        const html = parse(cleanHtmlString);
        return html;
    }

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}} sx={{px: 2}} >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                {datos && htmlFrom(datos.texto)}
            </Grid>

        </Grid>
    )

}
export default Dialogo_Politicas